"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealNameVerifyMode = void 0;
/**
 * 实名认证认证模式
 * AUTH: 认证鉴权模式，认证通过后需要继续进行登录鉴权
 * BIND: 认证绑定模式，认证通过后直接绑定实名信息
 */
var RealNameVerifyMode;
(function (RealNameVerifyMode) {
    RealNameVerifyMode[RealNameVerifyMode["AUTH"] = 1] = "AUTH";
    RealNameVerifyMode[RealNameVerifyMode["BIND"] = 2] = "BIND";
})(RealNameVerifyMode = exports.RealNameVerifyMode || (exports.RealNameVerifyMode = {}));
//# sourceMappingURL=verify-interface.js.map